import { ACTION_TYPES } from "../../../constants/index";

const initialState = {
  items: [],
};

const organizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_ORGANIZATION:
      return {
        ...state,
        items: action.payload,
      };
    case ACTION_TYPES.CLEAR_ORGANIZATION:
      return {
        ...state,
        items: [],
      };
    default:
      return state;
  }
};

export default organizationReducer;
